import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {CancelOfferStates} from "./types/CancelOfferTypes";
import withAuth from "../../hoc/withAuth";
import {Alert, Button, Card, Col, Collapse, Form, Input, Modal, Row, Select} from "antd";
import Cookies from "universal-cookie";
import {offerApiServices} from "../../services/offer/OfferApiService";
import currencyFormat from "../../helper/currencyFormat";
import CurrencyInput from "react-currency-input-field";
import {InfoCircleOutlined} from "@ant-design/icons";

const {Panel} = Collapse;

export interface CancelOfferProps {
}

class CancelOffer extends Component<CancelOfferProps & any, CancelOfferStates> {
    private readonly initState!: CancelOfferStates;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());
    private token = new Cookies().get('_t');
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    constructor(props: CancelOfferProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            companyCode: companyCode,
            offerCode: "",
            cancelReason: null,
            cancelCategory: null,
            fetchProcess: false,
            showFormCancel: false,
            cancelProcess: false,
            dataOrder: {},
            offerStatus: "",
            refundDeduction: 0,
            paidAmount: 0,
            fineInvoice: 0,
            cancelOfferModal: false,
            listCancelCategory: [""]
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dealerCode: data.value,
            offerCode: "",
            cancelReason: null,
            cancelCategory: null,
            fetchProcess: false,
            showFormCancel: false,
            cancelProcess: false,
            dataOrder: {},
            offerStatus: "",
            refundDeduction: 0,
            paidAmount: 0,
            fineInvoice: 0,
            cancelOfferModal: false,
            listCancelCategory: [""]
        });
    }

    getDataOffer = async () => {
        if (!this.state.offerCode) {
            Modal.error({title: 'Proses Gagal', content: 'Lengkapi data'});
            return;
        }
        const offerCodes = this.state.offerCode.split(",");
        if (offerCodes.length > 20) {
            Modal.error({
                title: 'Proses Gagal',
                content: "batch cancel offer dibatasi 20 offer"
            });
            await this.defaultState();
            return;
        }

        await this.promisedSetState({
            fetchProcess: true,
        });
        const values: any = [];
        const errors: any = [];
        await offerApiServices.setToken(this.token);
        await Promise.all(offerCodes.map(async (item: any) => {
            try {
                const value = await offerApiServices.getDetailOffer({
                    companyCode: this.state.companyCode,
                    offerCode: item?.trim(),
                    getDetailOrder: true,
                    getPayment: true,
                });

                values.push({
                    offerCode: item,
                    dataOrder: value.data?.data_order,
                    offerStatus: value.data?.data?.offer_status,
                    refundDeduction: value.data?.data?.refund_deduction ?? 0,
                    paidAmount: value.data?.data_payment?.total_paid_amount ?? 0,
                });
            } catch (e) {
                errors.push('Server Menolak Inputan Anda : ' + item + " " + e);
            }
        }));

        if (errors.length > 0) {
            Modal.error({title: 'Proses Gagal', content: errors.toString()});
            await this.defaultState();
            return;
        }

        if (values.length > 1) {
            for (const item of values) {
                if (item.offerStatus !== "OPEN") {
                    console.log(`${item.offerCode} -  ${item.offerStatus}`);
                }
            }
        }

        if (values.length > 1) {
            for (const item of values) {
                if (item.offerStatus !== "OPEN") {
                    Modal.error({
                        title: 'Proses Gagal',
                        content: `multi cancel offer hanya berlaku untuk offer dengan status OPEN, ${item.offerCode} -  ${item.offerStatus}`
                    });
                    await this.defaultState();
                    return;
                }
            }
        }

        await this.promisedSetState({
            fetchProcess: false,
            cancelReason: null,
            cancelCategory: null,
            showFormCancel: true,
            cancelProcess: false,
            dataOrder: values[0].dataOrder,
            offerStatus: values[0].offerStatus,
            refundDeduction: values[0].refundDeduction,
            paidAmount: values[0].paidAmount,
            fineInvoice: 0,
            cancelOfferModal: false,
            listCancelCategory: [""]
        });
    }

    cancelOffer = async () => {
        if (!this.state.cancelCategory || !this.state.cancelReason) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Mohon Lengkapi inputan'
            });
            return;
        }

        await this.promisedSetState({cancelOfferModal: true})
    }

    triggerCancelOffer = async () => {
        await this.promisedSetState({cancelProcess: true});

        const offerCodes = this.state.offerCode.split(",");
        const values: any = [];
        const errors: any = [];

        await offerApiServices.setToken(this.token);
        await Promise.all(offerCodes.map(async (item: any) => {
            const dataCancel = {
                company: this.state.companyCode,
                offer_code: item,
                cancel_category: this.state.cancelCategory,
                cancel_reason: this.state.cancelReason,
                fine_invoice: this.state.fineInvoice,
                admin_id: this.user,
                admin_name: this.user,
            }
            try {
                await offerApiServices.cancelOffer(dataCancel);
                values.push(`${item} success`);
            } catch (e) {
                errors.push('Server Menolak Inputan Anda : ' + item + " " + e?.toString());
            }
        }));

        Modal.success({
            title: 'Proses Sukses',
            content: (
                <div>
                    <h2>Success Cancel:</h2>
                    <p>{values.toString()}</p>
                    <br/>
                    <h2>Error Cancel:</h2>
                    <p>{errors.toString()}</p>
                </div>
            ),
        });
        await this.defaultState();
    }

    defaultState = async () => {
        await this.promisedSetState({
            cancelReason: null,
            cancelCategory: null,
            fetchProcess: false,
            showFormCancel: false,
            cancelProcess: false,
            dataOrder: {},
            offerStatus: "",
            cancelOfferModal: false,
            refundDeduction: 0,
            paidAmount: 0,
            fineInvoice: 0,
            listCancelCategory: [""]
        });
    }

    onFieldChange = <T extends keyof Pick<any, "offerCode" | "cancelReason" | "cancelCategory" | "fineInvoice">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "offerCode":
                currentState.offerCode = value;
                break;
            case "cancelReason":
                currentState.cancelReason = value;
                break;
            case "cancelCategory":
                currentState.cancelCategory = value;
                break;
            case "fineInvoice":
                currentState.fineInvoice = value;
                break;
        }

        let a = [""];
        if (target === "cancelCategory") {
            if (value === "TEST") {
                a = ["TEST DEVELOPER"];
            }
            if (value === "DEALER") {
                a = ["DUPLICATE PO", "INDENT TERLALU LAMA", "WARNA TIDAK SESUAI", "DP TIDAK SIAP", "GAGAL BAST", "GAGAL PELUNASAN", "CLOSING DENGAN SPK LAIN", "SALAH INPUT DATA", "PEMESAN NO RESPOND"];
            }
            if (value === "FINCO") {
                a = ["PENGAJUAN KREDIT DITOLAK", "TIDAK JADI KREDIT KENDARAAN", "PO PINDAH KE DEALER LAIN", "GAGAL BAST", "GAGAL PELUNASAN"];
            }
            if (value === "CUSTOMER") {
                a = ["TIDAK JADI BELI KENDARAAN", "MEMBELI DARI DEALER LAIN", "MEMBELI DARI MARKETING LAIN", "MEMBELI MERK LAIN", "INDENT TERLALU LAMA", "TIDAK ADA PROMO YANG COCOK", "WARNA TIDAK SESUAI", "MEMILIH TIPE LAIN", "GANTI WARNA", "GANTI MODEL/TIPE"];
            }
            currentState.listCancelCategory = a;
            currentState.cancelReason = null;
        }

        this.setState({
            ...currentState,
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Cancel Offer`} defaultSelectedKeys={['m-cancel-offer']} defaultOpenKeys={['sm-sm-sys-offer', 'sm-offer']}>
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <div style={{padding: 20}}>
                        <Row>
                            <Col xs={24} xl={12}>
                                <Card title="Cancel Offer" style={{margin: 10}}>
                                    <Collapse ghost>
                                        <Panel header={<span> <InfoCircleOutlined style={{color: "#1890ff"}}/> <i>Aturan Cancel Offer ... </i></span>} key="1">
                                            <Alert
                                                message="Cancel Offer"
                                                description={<div>
                                                    <ul>
                                                        <li>gunakan comma separator untuk multi offer</li>
                                                        <li>maksimal 20 kode offer dalam 1 batch <i className={`text-small-grey-nopadding`}>(terdapat pengecekan system)</i></li>
                                                        <li>multi cancel hanya berlaku pada offer dengan status OPEN <i className={`text-small-grey-nopadding`}>(terdapat pengecekan system)</i></li>
                                                        <li>nilai refund = nominal yang telah dibayar dikurangi nilai refund deduction <i className={`text-small-grey-nopadding`}>(berlaku pada offer yang memiliki pembayaran)</i></li>
                                                        <li>komponen denda hanya berlaku pada offer dengan type selain "OPEN"</li>
                                                        <li>offer dengan status CANCEL akan ditolak saat proses cancel <i className={`text-small-grey-nopadding`}>(terdapat pengecekan system)</i></li>
                                                    </ul>
                                                </div>}
                                                type="info"
                                                showIcon
                                                style={{marginBottom: 10}}
                                            />
                                        </Panel>
                                    </Collapse>
                                    <br/>
                                    <Form layout="vertical">
                                        <Form.Item>
                                            Kode Offer <i className={`text-small-grey-nopadding`}>*gunakan comma separator untuk multi offer</i>
                                            <Input value={this.state.offerCode} disabled={this.state.showFormCancel} placeholder="Kode Offer" onChange={event => this.onFieldChange("offerCode", event.target.value)}/>
                                        </Form.Item>
                                        <span style={!this.state.showFormCancel ? {display: 'none'} : {}}>
                                            <br/><br/>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey`}>Status Offer:</Col>
                                                <Col xs={24} xl={16}>{this.state.offerStatus ?? "-"}</Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey`}>Kode Order:</Col>
                                                <Col xs={24} xl={16}>{this.state.dataOrder?.code ?? "-"}</Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey`}>Status Order:</Col>
                                                <Col xs={24} xl={16}>{this.state.dataOrder?.status ?? "-"}</Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey`}>Paid Amount:</Col>
                                                <Col xs={24} xl={16}>{(this.state.paidAmount) ? currencyFormat(this.state.paidAmount) : "Rp 0"}</Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey`}>Refund Deduction:</Col>
                                                <Col xs={24} xl={16}>{(this.state.refundDeduction) ? currencyFormat(this.state.refundDeduction) : "Rp 0"}</Col>
                                            </Row><br/>

                                            <Form.Item style={this.state.offerStatus === "OPEN" ? {display: 'none'} : {}}>
                                                <div className={`text-small-grey`}>Komponen Denda</div>
                                                <CurrencyInput className={'ant-input'} value={this.state.fineInvoice} onValueChange={value => this.onFieldChange("fineInvoice", value ? parseFloat(value) : 0)}/>
                                            </Form.Item>
                                            <Form.Item>
                                                <div className={`text-small-grey`}>Kategori Alasan</div>
                                                <Select placeholder="Kategori Alasan" showSearch optionFilterProp="children" onChange={value => this.onFieldChange("cancelCategory", value)} value={this.state.cancelCategory}>
                                                    <Select.Option key={`DEALER`} value={`DEALER`}>{`DEALER`}</Select.Option>
                                                    <Select.Option key={`FINCO`} value={`FINCO`}>{`FINCO`}</Select.Option>
                                                    <Select.Option key={`CUSTOMER`} value={`CUSTOMER`}>{`CUSTOMER`}</Select.Option>
                                                    <Select.Option key={`TEST`} value={`TEST`}>{`TEST`}</Select.Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item label="Alasan Cancel">
                                                <Select placeholder="Alasan Cancel" showSearch optionFilterProp="children" onChange={value => this.onFieldChange("cancelReason", value)} value={this.state.cancelReason}>
                                                    {this.state.listCancelCategory.map((item: any, i: number) =>
                                                        <Select.Option key={i} value={item}>{item}</Select.Option>
                                                    )}
                                                </Select>
                                            </Form.Item>
                                            <br/>
                                            <Button type={"primary"} onClick={() => this.defaultState()}> Batalkan Proses Cancel</Button>
                                            &nbsp; &nbsp;
                                            <Button type={"primary"} loading={this.state.cancelProcess} onClick={() => this.cancelOffer()}> Cancel Offer</Button>
                                        </span>
                                        <span style={this.state.showFormCancel ? {display: 'none'} : {}}>
                                            <br/>
                                            <Button type={"primary"} loading={this.state.fetchProcess} onClick={() => this.getDataOffer()}> Get Data Offer</Button>
                                        </span>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <Modal
                        open={this.state.cancelOfferModal}
                        title="Konfirmasi CANCEL OFFER"
                        onCancel={() => this.setState({cancelOfferModal: false})}
                        cancelText={'Tutup'} okText={false}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button type={"primary"} loading={this.state.cancelProcess} key="1" onClick={this.triggerCancelOffer}>Cancel Offer</Button>,
                            <Button loading={this.state.cancelProcess} key="2" onClick={() => this.setState({cancelOfferModal: false})}>Close</Button>,
                        ]}
                    >
                        Anda Yakin Akan Malakukan <b>cancel</b> offer ? <br/><br/>
                    </Modal>

                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(CancelOffer), 35));